import ApiService from '../apiService';
import { trackEvent } from '@/utils/tracking';

export default {
  /*
    Error message types:
    DS_BRIDGE_NO_CURRENT_STEP
    DS_TRANSFORMER_NO_STEP
    DS_TRANSFORMER_NO_TRANSFORMER_ID
    DS_TRANSFORMER_NO_TRANSFORMER
    DS_TRANSFORMER_INVALID_INPUT
    DS_TRANSFORMER_INVALID_OUTPUT
    DS_TRANSFORMER_EXEC_ERROR
    DS_FILTER_NO_STEP
    DS_FILTER_NO_FILTER_ID
    DS_FILTER_NO_FILTER
    DS_FILTER_INVALID_INPUT
    DS_FILTER_INVALID_FILTER_TYPE
    DS_FILTER_EXEC_ERROR
    DS_FILTER_NOT_BOOLEAN
  */

  // **********************************************************
  //
  // CONSUMERS
  //
  // **********************************************************
  consumersFetch(tenantIds) {
    return ApiService.instance.get(`/consumer/list?tenantIds=[${tenantIds}]`).then((response) => {
      return response.data;
    });
  },

  async consumersCreate(tenantId, data) {
    const response = await ApiService.instance.post('/consumer/', { tenantId, ...data });
    trackEvent('consumers', 'createOne');
    return response.data;
  },

  async consumersUpdate(id, data) {
    const response = await ApiService.instance.put(`/consumer/${id}`, { id, ...data });
    trackEvent('consumers', 'updateOne');
    return response.data;
  },

  async consumersSetActive(id, active) {
    const response = await ApiService.instance.put(`/consumer/${id}`, { active });
    trackEvent('consumers', active ? 'activateOne' : 'deactivateOne');
    return response.data;
  },

  async consumersDelete(id) {
    const response = await ApiService.instance.delete(`/consumer/${id}`);
    trackEvent('consumers', 'deleteOne');
    return response.data;
  },

  // **********************************************************
  //
  // TRANSFORMERS
  //
  // **********************************************************

  consumerTransformersFetch(tenantIds) {
    return ApiService.instance.get(`/consumer/transformer/list?tenantIds=[${tenantIds}]`).then((response) => {
      return response.data;
    });
  },

  consumerTransformersGet(transformerId) {
    return ApiService.instance.get(`/consumer/transformer/${transformerId}`).then((response) => {
      return response.data;
    });
  },

  async consumerTransformersCreate(tenantId, data) {
    const response = await ApiService.instance.post('/consumer/transformer/', { tenantId, ...data });
    trackEvent('consumers', 'createTransformer');
    return response.data;
  },

  async consumerTransformersUpdate(id, data) {
    const response = await ApiService.instance.put(`/consumer/transformer/${id}`, { id, ...data });
    trackEvent('consumers', 'updateTransformer');
    return response.data;
  },

  async consumerTransformersDelete(id, cascadeDelete = false) {
    const response = await ApiService.instance.delete(`/consumer/transformer/${id}?cascadeDelete=${cascadeDelete}`);
    trackEvent('consumers', 'deleteTransformer');
    return response.data;
  },

  async consumerTransformersGetUsage(id) {
    const response = await ApiService.instance.get(`/consumer/transformer/${id}/usage`);
    return response.data;
  },

  consumerTransformersTest(data) {
    return ApiService.instance.post('/consumer/transformer/test/', data).then((response) => {
      return response.data;
    });
  },

  // **********************************************************
  //
  // FILTERS
  //
  // **********************************************************
  consumerFiltersFetch(tenantIds) {
    return ApiService.instance.get(`/consumer/filter/list?tenantIds=[${tenantIds}]`).then((response) => {
      return response.data;
    });
  },

  async consumerFiltersCreate(tenantId, data) {
    const response = await ApiService.instance.post('/consumer/filter/', { tenantId, ...data });
    trackEvent('consumers', 'createFilter');
    return response.data;
  },

  async consumerFiltersUpdate(id, data) {
    const response = await ApiService.instance.put(`/consumer/filter/${id}`, { id, ...data });
    trackEvent('consumers', 'updateFilter');
    return response.data;
  },

  async consumerFiltersDelete(id, cascadeDelete = false) {
    const response = await ApiService.instance.delete(`/consumer/filter/${id}?cascadeDelete=${cascadeDelete}`);
    trackEvent('consumers', 'deleteFilter');
    return response.data;
  },

  async consumerFiltersGetUsage(id) {
    const response = await ApiService.instance.get(`/consumer/filter/${id}/usage`);
    return response.data;
  },
};
